let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1dmcg")).then(() => parcelRequire('46KFl'));